// app/contact/page.jsx
"use client";

import { useState, useEffect, useRef } from "react";
import { useParams } from "next/navigation";
import HeaderInner from "@/components/HeaderInner";
import * as ReactDOM from "react-dom";
import { getUserInfo } from "../../../../utilities/userInfo";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import Link from "next/link";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";
import HotelContactForm from "./HotelContactForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faEnvelope,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
import TigerLoader from "@/components/TigerLoader";
import "./contact.css"

export default function ContactPage() {
  const [propertyData, setPropertyData] = useState([])
  const [propertyId, setPropertyId] = useState(null);
  const { propertySlug } = useParams();
  const [showFullDesc, setShowFullDesc] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const filterBarRef = useRef(null);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [brandData, setBrandData] = useState([]);

  const brandColors = {
    1: "#bf1e2d",
    4: "#bf1e2d",
    2: "#263997",
    3: "#f04e02",
    5: "#febb19",
    6: "#f9e12e",
  };

  const backgroundColor = brandColors[brandId] || "#f26624";

  useEffect(() => {
    typeof window !== "undefined" && window.scrollTo(0, 0);
    const storedBrandId = localStorage.getItem('brandId');
    setBrandId(storedBrandId);
  }, []);


  const toggleDescription = () => {
    setShowFullDesc(!showFullDesc);
  };

  useEffect(() => {
    const storedBrandId = localStorage.getItem('brandId');
    setBrandId(storedBrandId);
  }, []);

  // Fetch brand data
          useEffect(() => {
            (async () => {
              try {
                const res = await fetch(
                  `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetBrandList`
                );
                const json = await res.json();
                setBrandData(json.data || []);
              } catch (e) {
                console.error("Error fetching brands:", e);
              }
            })();
          }, []);

  useEffect(() => {
    if (!propertySlug) return;

    const fetchPropertyIdFromSlug = async (slug) => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetPropertyList`
        );
        const json = await res?.json();
        if (json.errorMessage !== "success") {
          console.error("Property list fetch error:", json);
          return null;
        }
        const found = json.data.find((p) => p.propertySlug === propertySlug)
        setPropertyData(found);
        setCityDetails({ label: found?.cityName, value: found?.cityId, property_Id: found?.staahPropertyId });
        setStaahPropertyId(found?.staahPropertyId);
        return found?.propertyId || null;
      } catch (error) {
        console.error("Error fetching property list:", error);
        return null;
      } finally {
        setIsPageLoading(false)
      }
    };

    const loadPropertyId = async () => {
      // setLoading(true);
      const id = await fetchPropertyIdFromSlug(propertySlug);
      setPropertyId(id);
      // setLoading(false);
    };

    loadPropertyId();
  }, [propertySlug]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneCode: "+91",
    phone: "",
    query: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handlePropertyBookNow = async () => {
    setOpen(!isOpen);
    setShowFilterBar(!showFilterBar);
    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button"
      );
      if (firstInput) firstInput.focus();
    }
  };

  async function postBookingWidged(rooms, mapping, isClose, ctaName, selectedPropertyId) {
    const resp = await getUserInfo();
    const sessionId = sessionStorage?.getItem("sessionId");
    const payload = {
      ctaName: ctaName,
      urls: window.location.href,
      cityId: "0",
      propertyId: selectedPropertyId?.toString() || "0",
      checkIn: "",
      checkOut: "",
      adults: "0",
      children: "0",
      rooms: "0",
      promoCode: "",
      ip: resp?.ip,
      sessionId: sessionId,
      deviceName: resp?.deviceInfo?.deviceName,
      deviceType: resp?.deviceInfo?.deviceOS == "Unknown" ? resp?.deviceInfo?.platform : resp?.deviceInfo?.deviceOS,
      roomsName: rooms?.RoomName,
      packageName: mapping?.MappingName,
      isCartOpen: mapping?.MappingName ? "Y" : "N",
      isCartEdit: "N",
      isCartClick: "N",
      isClose: isClose ? "Y" : "N",
    }
       const response = await fetch(
         `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/Api/tracker/BookingWidged`,
         {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: JSON.stringify( payload ),
         }
       );
       const res = await response?.json();
  }

  if (isPageLoading) {
    return (
      <TigerLoader />
    );
  }

  return (
    <>
      <main style={{ overflowY: "auto" }}>
        <HeaderInner brandData={brandData} propertyData={propertyData} brandId={brandId} backgroundColor={backgroundColor} propertyId={propertyData?.propertyId} onClick={handlePropertyBookNow} />
        <section ref={filterBarRef} className="position-relative">
          <section className="position-fixed start-0 w-100 bg-white shadow" ref={filterBarRef}>
            {showFilterBar && typeof window !== "undefined" && ReactDOM.createPortal(
              <section className="filter-bar-hotels-cin">
                <BookingEngineProvider>
                  <FilterBar
                    selectedProperty={parseInt(staahPropertyId)}
                    cityDetails={cityDetails}
                    openBookingBar={showFilterBar}
                    onClose={(isReload) => {
                      setOpen(false);
                      setShowFilterBar(false);
                      if (isReload) {
                        window.location.reload();
                      }
                    }}
                    isCloseButtonShow="true"
                    backgroundColor={backgroundColor}
                  />
                </BookingEngineProvider>
              </section>,
              document.body
            )}
          </section>
        </section>

        <div style={{ paddingTop: "130px" }}></div>
        <section>
          <div className="container">
            <div className="global-heading-sec text-center">
              <div className="row justify-content-center mb-2">
                <div className="col-md-9 md-offset-1">
                  <h1 className="global-heading fw-semibold !text-[23px] mb-3" style={{ color: backgroundColor }}>CONTACT US</h1>
                  <div className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4" style={{ background: backgroundColor }}></div>
                </div>
              </div>
            </div>

            {/* <HotelContactUs></HotelContactUs> */}

            <section>
              <div className="bg-light pb-3 pt-3">
                <div className="container-md contact-addres">
                  <div className="row">
                    <div className="col-12 col-lg-4 col-sm-4">
                      <div className="item">
                        <span className="icon feature_box_col_three">
                          <FontAwesomeIcon icon={faMobileAlt} />
                        </span>
                        <h6>Reservation Phone</h6>
                        <p>
                          <Link
                            className="text-lowercase text-decoration-none"
                            href={`tel:${propertyData?.contactDetails?.[0]?.contactNo1 || ""
                              }`}
                          >
                            {propertyData?.contactDetails?.[0]?.contactNo1 || ""}
                          </Link>
                        </p>
                        <p>
                          <Link
                            className="text-lowercase text-decoration-none"
                            href={`tel:${propertyData?.contactDetails?.[0]?.contactNo2 || ""
                              }`}
                          >
                            {propertyData?.contactDetails?.[0]?.contactNo2 || ""}
                          </Link>
                        </p>
                        <p>
                          <Link
                            className="text-lowercase text-decoration-none"
                            href={`tel:${propertyData?.contactDetails?.[0]?.tollFreeNumber ||
                              ""
                              }`}
                          >
                            {propertyData?.contactDetails?.[0]?.tollFreeNumber ||
                              ""}
                          </Link>
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4 col-sm-4">
                      <div className="item">
                        <span className="icon feature_box_col_two">
                          <FontAwesomeIcon icon={faLocationDot} />
                        </span>
                        <h6>Address:</h6>
                        <p>
                          {propertyData?.addressDetails?.[0]?.address1 || ""}
                          {propertyData?.addressDetails?.[0]?.address2 || ""}
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-4 col-sm-4">
                      <div className="item">
                        <span className="icon feature_box_col_three">
                          <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                        <h6>Reservation Email</h6>
                        <p>
                          <Link
                            className="text-lowercase text-decoration-none"
                            href={`mailto:${propertyData?.contactDetails?.[0]?.emailId1 || ""
                              }`}
                          >
                            {propertyData?.contactDetails?.[0]?.emailId1 || ""}
                          </Link>
                        </p>
                        <p>
                          <Link
                            className="text-lowercase"
                            href={`mailto:${propertyData?.contactDetails?.[0]?.emailId2 || ""
                              }`}
                          >
                            {propertyData?.contactDetails?.[0]?.emailId2 || ""}
                          </Link>
                        </p>

                        <p>
                          <Link
                            className="text-lowercase"
                            href={`mailto:${propertyData?.contactDetails?.[0]
                              ?.reservationEmail || ""
                              }`}
                          >
                            {propertyData?.contactDetails?.[0]
                              ?.reservationEmail || ""}
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <HotelContactForm
              backgroundColor={backgroundColor}
              cityId={propertyData?.cityId}
              propertyId={propertyData?.propertyId}
              longitude={propertyData?.addressDetails?.[0]?.longitude}
              latitude={propertyData?.addressDetails?.[0]?.lattitude}
              googleMap={propertyData?.addressDetails?.[0]?.googleMap}
            />
          </div>
        </section>
        <style jsx>{`
  .item {
    transition: all 0.3s ease;
  }

  .item:hover {
    background: ${backgroundColor};
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    transform: translateY(-5px);
  }

  /* Make ALL text white */
  .item:hover h6,
  .item:hover p {
    color: #fff !important;
  }

  /* Make ALL anchor tags white */
  .item:hover :global(a) {
    color: #fff !important;
  }

  /* Make icon wrapper white */
  .item:hover .icon {
    color: #fff !important;
    transform: scale(1.1);
  }

  /* Make the underlying FontAwesome SVG white */
  .item:hover :global(svg) {
    fill: #fff !important;
    color: #fff !important;
  }
`}</style>
      </main>
    </>
  );
}
